import styled from '@emotion/styled';
import { theme } from '~/theme';
import Minus from '~/icons/minus.svg';
import Plus from '~/icons/plus.svg';
import { breakpoints } from '~/theme/breakpoints';
import { ifProp } from 'styled-tools';

export const StyledInputGroup = styled.div(() => ({
    padding: `0`,
    border: `1px solid ${theme.colors.headerSearchInputNewColor}`,
    borderRadius: theme.sizes.cornerRadius,
    fontSize: theme.fontSizes['2xs'],

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: theme.space[5],

    width: theme.space[8],
}));

export const StyledInputMinus = styled(Minus)<{ disabled?: boolean }>(
    () => ({
        cursor: 'pointer',
        fontSize: theme.fontSizes['md'],
        strokeWidth: '2px',
        ':focus-visible': {
            position: 'relative',
            zIndex: 1,
            boxShadow: theme.shadows.accessibility,
        },
    }),
    ifProp('disabled', {
        cursor: 'not-allowed',
        opacity: 0.3,
    }),
);

export const StyledInputPlus = styled(Plus)<{ disabled?: boolean }>(
    () => ({
        cursor: 'pointer',
        fontSize: theme.fontSizes['md'],
        strokeWidth: '2px',
        ':focus-visible': {
            position: 'relative',
            zIndex: 1,
            boxShadow: theme.shadows.accessibility,
        },
    }),
    ifProp('disabled', {
        cursor: 'not-allowed',
        opacity: 0.3,
    }),
);

export const StyledInputQuantity = styled.input(
    () => ({
        position: 'relative',
        fontWeight: theme.fontWeights.bold,
        padding: 0,
        resize: 'vertical',
        border: 'none',
        textAlign: 'center',
        width: '30px',
        webkitAppearance: 'none',
        margin: 0,
        fontSize: theme.fontSizes['2xs'],
        ':focus-visible': {
            boxShadow: theme.shadows.accessibility,
        },
        [breakpoints.md]: {
            width: '25px',
        },
    }),
    ifProp('readOnly', {
        cursor: 'not-allowed',
        opacity: 0.75,
    }),
);
